"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopoverWidget = exports.PopoverAlertType = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var DomUtil_1 = require("../../utils/DomUtil");
var ReactHelpers_1 = require("../../utils/ReactHelpers");
var AlertStyles_1 = require("../AlertStyles");
Object.defineProperty(exports, "PopoverAlertType", { enumerable: true, get: function () { return AlertStyles_1.AlertType; } });
var PopoverBase_1 = require("./PopoverBase");
var PopoverStyles_1 = require("./PopoverStyles");
var PopoverComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PopoverComponent, _super);
    function PopoverComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { isVisible: false };
        _this.triggerEl = null;
        _this.defaultPopoverId = DomUtil_1.generateId();
        _this.getPopoverId = function () { return _this.props.id || _this.defaultPopoverId; };
        _this.defaultTriggerId = DomUtil_1.generateId();
        _this.getTriggerId = function () {
            var triggerElement = _this.props.triggerElement;
            return (triggerElement instanceof HTMLElement ? triggerElement.id : triggerElement.props.id) || _this.defaultTriggerId;
        };
        _this.handleClose = function () { return _this.setState({ isVisible: false }); };
        _this.handleClick = function (e) {
            _this.triggerEl = e.currentTarget;
            _this.setState(function (_a) {
                var isVisible = _a.isVisible;
                return ({ isVisible: !isVisible });
            });
        };
        return _this;
    }
    PopoverComponent.prototype.toggle = function (shown) {
        if (shown === void 0) { shown = !this.state.isVisible; }
        if (shown && !this.triggerEl) {
            this.triggerEl = document.getElementById(this.getTriggerId());
        }
        this.setState({ isVisible: shown });
    };
    PopoverComponent.prototype.updateTriggerAttrs = function () {
        var triggerElement = this.props.triggerElement;
        var isVisible = this.state.isVisible;
        if (triggerElement instanceof HTMLElement) {
            triggerElement.addEventListener('click', this.handleClick); // this is a no-op in the case of re-adding a listener that's already added
            triggerElement.setAttribute(ReactHelpers_1.EventUtilsOptOutAttr, "true");
            triggerElement.setAttribute('aria-haspopup', 'dialog');
            if (isVisible) {
                triggerElement.setAttribute('aria-controls', this.getPopoverId());
            }
            else {
                triggerElement.removeAttribute('aria-controls');
            }
            this.triggerEl = triggerElement;
        }
    };
    PopoverComponent.prototype.componentDidMount = function () {
        this.updateTriggerAttrs();
    };
    PopoverComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevProps.triggerElement !== this.props.triggerElement || prevState.isVisible !== this.state.isVisible) {
            this.updateTriggerAttrs();
        }
    };
    PopoverComponent.prototype.componentWillUnmount = function () {
        var triggerElement = this.props.triggerElement;
        if (triggerElement instanceof HTMLElement) {
            triggerElement.removeAttribute('aria-haspopup');
            triggerElement.removeAttribute('aria-controls');
            triggerElement.removeEventListener('click', this.handleClick);
            triggerElement.removeAttribute(ReactHelpers_1.EventUtilsOptOutAttr);
        }
    };
    PopoverComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, triggerElement = _a.triggerElement, popoverProps = tslib_1.__rest(_a, ["triggerElement"]);
        var isVisible = this.state.isVisible;
        var clonedTrigger = triggerElement instanceof HTMLElement ? null : React.cloneElement(triggerElement, tslib_1.__assign(tslib_1.__assign({}, ReactHelpers_1.EventUtilsOptOut), { 'aria-controls': isVisible ? this.getPopoverId() : undefined, 'aria-haspopup': 'dialog', className: TypeStyle.classes(triggerElement.props.className, PopoverStyles_1.PopoverTriggerStyleName), id: this.getTriggerId(), onClick: function (e) {
                var _a, _b;
                _this.handleClick(e);
                (_b = (_a = triggerElement.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            } }));
        return React.createElement(React.Fragment, null,
            clonedTrigger,
            isVisible && this.triggerEl &&
                React.createElement(PopoverBase_1.PopoverBase, tslib_1.__assign({}, popoverProps, { id: this.getPopoverId(), onClose: this.handleClose, triggerElement: this.triggerEl })));
    };
    return PopoverComponent;
}(React.PureComponent));
// We migrated the PopoverWidget to a class component to support extending the `triggerElement` API to accept `HTMLElement`.
// We added this FC wrapper to maintain backwards compatibility with using a `PopoverInstance` `ref`.
exports.PopoverWidget = React.forwardRef(function (props, ref) {
    var popoverInstance = React.useRef(null);
    React.useImperativeHandle(ref, function () { return ({ toggle: function (shown) { var _a; return (_a = popoverInstance.current) === null || _a === void 0 ? void 0 : _a.toggle(shown); } }); });
    return React.createElement(PopoverComponent, tslib_1.__assign({}, props, { ref: popoverInstance }));
});
exports.PopoverWidget.displayName = 'PopoverWidget';
exports.PopoverWidget.defaultProps = {
    placement: 'auto',
    width: 300,
    zIndex: 1,
};
//# sourceMappingURL=PopoverWidget.js.map